import type { TabsProps } from '@cloudscape-design/components/tabs';

export const filterEmptyTabs = (tabs: TabsProps.Tab[]) =>
  tabs.filter((c) => c.label && c.label.toString().replace(' ', '').length > 0);
